<template>
  <ModalBootstrap aria-label="Click to close this window" @modal-open-event="OnModalOpen" @modal-close-event="OnModalClose" :ModalId="modalId"
    :ModalTitle="modalTitle" :ButtonText="buttonText" ref="registrationModal" ModalSizeClass="modal-xl">
    <template v-slot:body>

      <!-- {{ formData }} -->
      <form @submit="AddUpdateUser" v-if="((notSubmitted == true) && (loadingCac == false))">

        <div class="row">

          <div class="col">

            <div v-if="(withCac == true)">
              <div v-if="(this.cacInfo.message != null)">

                  <label id="caclabel" for="certMessage" class="form-label w-100 cacLabel">
                      CAC Subject Name
                      <p aria-labelledby="caclabel" aria-live="polite" class="cacInfo" id="certMessage">{{ cacInfo.message }}</p>
                  </label>
              </div>
              <div v-else>

                  <label id="cacsub" for="certificateCommonName" class="form-label w-100 cacLabel">
                      CAC Subject Name
                      <p aria-labelledby="cacsub" aria-live="polite" class="cacInfo" id="certificateCommonName">{{ cacInfo.certificateCommonName }}</p>
                  </label>
              </div>
            </div>
          </div>


        </div>

        <div class="row">

          <div class="col">
            <div class="mb-3">

              <TextInput aria-label="Enter your email" aria-live="polite" input-id="emailInput" label-text="Email" :input-v-model="formData.email" object-key="email"
                :my-errors="v$.formData.email.$errors" @update-form="UpdateForm" @blur="v$.formData.email.$touch">
              </TextInput>

            </div>
          </div>

          <div class="col">
            <div class="mb-3">
              <TooltipComponent id="passwordHelp" position="left"
                tooltip-text="Passwords require a minimum of 15 characters, and at least 1 of the following character sets: Upper Case Letter, Lower Case Letter, Number, and Special Character (EX: #?!@$%^&*-)">

                <TextInput aria-live="polite" text-mode="password" input-id="passwordInput" label-text="Password"  :input-v-model="formData.password" object-key="password" :my-errors="v$.formData.password.$errors" @update-form="UpdateForm" @blur="v$.formData.password.$touch"></TextInput>
               
              </TooltipComponent>

            </div>
          </div>

          <div class="col">
            <div class="mb-3">

              <TooltipComponent position="left" tooltip-text="Must Match Password Input">
                <TextInput aria-label="Re-enter your password to confirm they match" aria-live="polite" text-mode="password" input-id="passwordConfirmInput" label-text="Confirm Password"
                  :input-v-model="formData.passwordConfirm" object-key="passwordConfirm"
                  :my-errors="v$.formData.passwordConfirm.$errors" @update-form="UpdateForm"
                  @blur="v$.formData.passwordConfirm.$touch"></TextInput>
              </TooltipComponent>

            </div>
          </div>

        </div>

        <div class="row">
          <div class="col">
            <div class="mb-3">

              <TextInput aria-label="Enter your First Name" aria-live="polite" aria-required="true" input-id="firstNameInput" label-text="First Name" :input-v-model="formData.firstName"
                object-key="firstName" :my-errors="v$.formData.firstName.$errors" @update-form="UpdateForm"
                @blur="v$.formData.firstName.$touch"></TextInput>

            </div>
          </div>

          <div class="col">
            <div class="mb-3">

              <TextInput aria-label="Enter your Middle Name" aria-live="polite" input-id="middleNameInput" label-text="Middle Name" :input-v-model="formData.middleName"
                object-key="middleName" @update-form="UpdateForm"></TextInput>

            </div>
          </div>

          <div class="col">
            <div class="mb-3">

              <TextInput aria-label="Enter your Last Name" aria-live="polite" aria-required="true" input-id="lastNameInput" label-text="Last Name" :input-v-model="formData.lastName"
                object-key="lastName" :my-errors="v$.formData.lastName.$errors" @update-form="UpdateForm"
                @blur="v$.formData.lastName.$touch"></TextInput>

            </div>
          </div>
        </div>

        <div class="row">

          <div class="col-md-4">
            <div class="mb-3">

              <TextInput aria-label="Enter your telephone number" aria-live="polite" aria-required="true" input-id="phoneInput" label-text="Phone" :input-v-model="formData.phone" object-key="phone"
                :my-errors="v$.formData.phone.$errors" @update-form="UpdateForm" @blur="v$.formData.phone.$touch">
              </TextInput>

            </div>
          </div>

          <div class="col-md-4">

            <div class="mb-3">

              <TextInput aria-label="Enter your position/duty title" aria-live="polite" aria-required="false" input-id="titleInput" label-text="Title" :input-v-model="formData.title" object-key="title"
                @update-form="UpdateForm"></TextInput>

            </div>
          </div>

        </div>

        <div class="row">

          <div class="col">

            <!-- [ServiceRankId] FE BE Dropdown -->
              <div class="mb-3">


                  <DropdownInputSearchable
                    :options="serviceRankDropdownValues"         
                    :my-errors="v$.formData.serviceRankId.$errors"
                    @update-form="UpdateForm"
                    @blur="v$.formData.serviceRankId.$touch"
                    object-key="serviceRankId"
                    label-text="Service Rank"
                    input-id="serviceRankId"
                    label-id="serviceRankId_label"
                    error-id="serviceRankId_error"
                    :aria-required="true" 
                    placeholder="Select, or Search for a Service Rank">
                  </DropdownInputSearchable>

              </div>

          </div>

          <div class="col">

            <!-- [CountryId] FE BE Dropdown -->
            <div class="mb-3">

              <DropdownInputSearchable aria-label="Select your country from the drop down list" aria-live="polite" aria-required="true" role="listbox" :options="countryDropdownValues" :my-errors="v$.formData.countryId.$errors"
                @update-form="UpdateForm" @blur="v$.formData.countryId.$touch" object-key="countryId"
                placeholder="Select, or Search for a Country" label-text="Country" ref="countryDropdown">
              </DropdownInputSearchable>

            </div>

          </div>

          <div class="col">
            <!-- [CampLocationId] FE BE Dropdown  -->
            <div class="mb-3">

              <DropdownInput aria-label="Select your camp location from the drop down list" aria-live="polite" aria-required="true" role="listbox" input-id="campLocation" label-text="Camp Location" :input-v-model="formData.campLocationId"
                object-key="campLocationId" :option-list="campLocationDropdownValues"
                :my-errors="v$.formData.campLocationId.$errors" @update-form="UpdateForm"
                @blur="v$.formData.campLocationId.$touch"></DropdownInput>

            </div>
          </div>

        </div>

        <div class="row">

          <div class="col">
            <!-- [RoleId] FE BE Dropdown -->
            <div class="mb-3">

              <DropdownInput aria-label="Select your role from the drop down list" aria-live="polite" aria-required="true" input-id="role" role="listbox" label-text="Role" :input-v-model="formData.roleId" object-key="roleId"
                :option-list="roleDropdownValues" :my-errors="v$.formData.roleId.$errors" @update-form="UpdateForm"
                @blur="v$.formData.roleId.$touch"></DropdownInput>

            </div>
          </div>

          <div class="col">
            <div class="mb-3">

              <DropdownInputSearchable aria-label="Select your Contract number from the drop down list" aria-live="polite" aria-required="true" :options="contractDropdownValues" :my-errors="v$.formData.contractId.$errors"
                @update-form="UpdateForm" @blur="v$.formData.contractId.$touch" object-key="contractId"
                placeholder="Select, or Search for a Contract" label-text="Contract" ref="contractDropdown">
              </DropdownInputSearchable>

            </div>
          </div>

          <div class="col">
            <div class="mb-3" v-if="(formData.roleId == 2 || formData.roleId == 5)">

              <DropdownInput aria-label="Select your company from the drop down list" aria-live="polite" aria-required="true" input-id="company" label-text="Company" :input-v-model="formData.companyId"
                object-key="companyId" :option-list="companyDropdownValues" @update-form="UpdateForm" :my-errors="v$.formData.companyId.$errors" 
                @blur="v$.formData.companyId.$touch"></DropdownInput>

            </div>
            <div v-else-if="(formData.roleId != 2) && (formData.roleId != 0)" class="mb-3">

              <label for="redeployDate" class="form-label">Redeployment Date</label>
              <input aria-label="Enter your re-deployent date" aria-live="polite" type="date" class="form-control" id="redeployDate" v-model="formData.redeployDate">

            </div>
          </div>

        </div>

      </form>

      <div v-else>
        <LoadingGifVue aria-hidden="true"></LoadingGifVue>
        <span aria-live="polite" class="w-75 float-right">(Loading CAC Information. Please note: It may take a few seconds for your Browser
          to Prompt you to enter your PIN)</span>
      </div>

    </template>

    <template v-slot:footer>
      <button tabindex="0" role="button" aria-label="Click to complete your registraton" @click="RegisterUser" class="btn btn-primary">Register</button>
    </template>
  </ModalBootstrap>
</template>

<script>
import ModalBootstrap from "@/components/dataSupport/ModalBootstrap.vue";
import { store } from "../../store/store.js";
import { ajaxGeneralHelper, ajaxGetAndReturn } from "@/components/helpers/utilities.js";
import $ from "jquery";
import LoadingGifVue from "../dataSupport/LoadingGif.vue";
import { useVuelidate } from '@vuelidate/core';
import RegistrationFormViewModel from "./RegistrationFormViewModel.js";
import TextInput from "../formComponents/TextInput.vue";
import DropdownInput from "../formComponents/DropdownInput.vue";
import DropdownInputSearchable from "@/components/formComponents/DropdownInputSearchable.vue";
import TooltipComponent from "@/components/dataSupport/TooltipHelper.vue";

export default {
  name: "registrationForm",
  components: {
    ModalBootstrap, LoadingGifVue, TextInput, DropdownInput, DropdownInputSearchable, TooltipComponent
  },
  props: {
    modalId: String,
    withCac: Boolean,
    modalTitle: String
  },
  data() {
    return {
      formData: new RegistrationFormViewModel(),
      notSubmitted: true,
      store,
      serviceRankDropdownValues: [],
      roleDropdownValues: [],
      countryDropdownValues: [],
      campLocationDropdownValues: [],
      contractDropdownValues: [],
      companyDropdownValues: [],
      buttonText: "Register",
      loadingCac: false,
      cacInfo: {}
    };
  },
  mounted() {
    this.InitialSetup();
  },
  setup() {
    return { v$: useVuelidate() }
  },
  methods: {
    InitialSetup() {
      if (this.withCac) {
        this.buttonText = "Register With CAC";
      }
      else {
        this.loadingCac = false;
      }
    },
    async OnModalOpen() {
      //console.log("modal opening", this, this.serviceRankDropdownValues, this.formData);

      if (this.$refs.serviceRankDropdown != null)
        this.$refs.serviceRankDropdown.ClearInput();
      if (this.$refs.countryDropdown != null)
        this.$refs.countryDropdown.ClearInput();
      if (this.$refs.contractDropdown != null)
        this.$refs.contractDropdown.ClearInput();

      //reset form by reassigning it to a fresh view model:
      Object.assign(this.formData, new RegistrationFormViewModel());
      this.v$.$reset(); //reset validation props
      this.formData.emailInUse = false;

      //get dropdown values
      if (this.serviceRankDropdownValues == undefined || this.serviceRankDropdownValues.length == 0) {
        ajaxGetAndReturn(store.webAPIUrl + "ServiceRanks/getDropdown", (result) => {
          this.serviceRankDropdownValues = result;
        });
      }

      if (this.roleDropdownValues == undefined || this.roleDropdownValues.length == 0) {
        ajaxGetAndReturn(store.webAPIUrl + "Roles/getDropdown", (result) => {
          this.roleDropdownValues = result;
        });
      }
      if (this.countryDropdownValues == undefined || this.countryDropdownValues.length == 0) {
        ajaxGetAndReturn(store.webAPIUrl + "Countries/getDropdown", (result) => {
          this.countryDropdownValues = result;
        });
      }
      if (this.campLocationDropdownValues == undefined || this.campLocationDropdownValues.length == 0) {
        ajaxGetAndReturn(store.webAPIUrl + "CampLocations/getDropdown", (result) => {
          this.campLocationDropdownValues = result;
        });
      }
      if (this.contractDropdownValues == undefined || this.contractDropdownValues.length == 0) {
        ajaxGetAndReturn(store.webAPIUrl + "Contracts/getDropdown", (result) => {
          this.contractDropdownValues = result;
        });
      }
      if (this.companyDropdownValues == undefined || this.companyDropdownValues.length == 0) {
        ajaxGetAndReturn(store.webAPIUrl + "companies/getDropdown", (result) => {
          this.companyDropdownValues = result;
        });
      }

      if (this.withCac) {
        this.loadingCac = true;
        // console.log("loading Cac");
        var wakeupUrl = process.env.VUE_APP_CAC_URL + "wakeup";
        $.ajax({
          method: "GET",
          url: wakeupUrl
        }).always(async (data) => {
          // console.log(data, "hand shaking with CAC service.");

          var cacInfo = await this.GetCacInfo();
          this.cacInfo = cacInfo;
          // console.log(cacInfo);

          this.formData.certificateCommonName = cacInfo.commonName;
          this.formData.firstName = cacInfo.firstName;
          this.formData.lastName = cacInfo.lastName;
          this.loadingCac = false;
        });
      }
      else {
        this.loadingCac = false;
      }

    },
    //Add new User, or Edit existing user (based on prescense of user Id)
    async RegisterUser(e) {
      e.preventDefault();
      //console.log("registering user", this.v$.$errors);
      await this.v$.$validate();
      // you can show some extra alert to the user or just leave the each field to show it's `$errors`.
      this.formData.emailInUse = false;
      if (this.v$.formData.email.$errors.length == 0) {
        //if the form is invalid, but email is valid, do an email check
        console.log("email is valid");
        await $.ajax({
          method: "GET",
          url: store.webAPIUrl + "Auth/CheckIfEmailIsInUse/" + this.formData.email,
          success: (result) => {
            //console.log(result); 
            if (!result.validEmail) this.formData.emailInUse = true;
          },
        });
      }

      const isFormCorrect = await this.v$.$validate();
      if (!isFormCorrect) {

        return;
      }

      //default ajax url and method to POST (insert new user)
      let ajaxUrl = store.webAPIUrl + "Auth/Register";
      //then perform ajax post request with that url
      ajaxGeneralHelper(ajaxUrl, "POST", this.formData, (result) => {
        result;
        this.$refs.registrationModal.HideModal();
        this.$router.push({ name: "landing" });
      });

    },
    async GetCacInfo() {

      var cacData = {
        commonName: "Loading...",
        firstName: "",
        lastName: ""
      };
      this.cacData = cacData;
      var cacUrl = process.env.VUE_APP_CAC_URL;
      await $.ajax({
        method: "GET",
        url: cacUrl,
        success: (result) => {
          if (result.commonName != "") {

            cacData = {
              commonName: result.commonName,
              firstName: result.firstName,
              lastName: result.lastName,
              cacPresent: true
            }
          }
          else {
            cacData = {
              commonName: "",
              firstName: "",
              lastName: "",
              message: "CAC info not found for this CAC card. Try restarting the browser.",
              cacPresent: false
            }
          }
        },
        error: (errorThrown) => {
          console.log(errorThrown);
        },
      });

      return cacData;
    },

    UpdateForm(objKey, modelData) {
      //console.log(objKey, modelData);
      this.formData[objKey] = modelData;
    },
    async OnModalClose() {
      //this.formData = null; 
      //console.log("closing registration modal");
      if (this.$refs.serviceRankDropdown != null)
        this.$refs.serviceRankDropdown.ClearInput();
    }
  },
  validations() {
    return this.formData.GetValidationRules(this.formData);
  }
};
</script>

<style>    
    .errorMsg {
        color: #DC143C;
    }

.cacLabel {
  text-align: left;
}

.cacInfo {
  width: 100%;
  display: inline-block;
  text-align: left;
}</style>
